function isTouchDevice(): boolean {
  return typeof window !== 'undefined' ? 'ontouchstart' in window || navigator.maxTouchPoints > 0 : false;
}

const isLandscape = () => window.innerWidth < 1024 && window.innerHeight < window.innerWidth;

const windowPage = typeof window !== 'undefined' ? window : null;

export default {
  isTouchDevice,
  isLandscape,
  windowPage,
};
